import React, { useState } from "react";
import { collection, doc, getDocs, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "../lib/firebase";

export default function AdminSeedGiftFields() {
  const [running, setRunning] = useState(false);
  const [msg, setMsg] = useState("");
  const [debug, setDebug] = useState([]);

  function addDebug(line) {
    console.log(line);
    setDebug((prev) => [...prev, line]);
  }

  async function seed() {
    setRunning(true);
    setMsg("");
    setDebug([]);

    addDebug("🚀 Seed process started...");
    addDebug("🔍 Fetching collection: datingProfiles");

    try {
      const snap = await getDocs(collection(db, "datingProfiles"));
      addDebug(`📦 Total docs found: ${snap.size}`);

      if (!snap.size) {
        setMsg("❌ No profiles found in collection: datingProfiles");
        setRunning(false);
        return;
      }

      let updated = 0;
      let skipped = 0;

      let batch = writeBatch(db);
      let batchCount = 0;

      for (const d of snap.docs) {
        const data = d.data() || {};
        const ref = doc(db, "datingProfiles", d.id);

        const sent = data.giftCoinsSent;
        const received = data.giftCoinsReceived;

        const needsSent = sent == null; // undefined or null
        const needsReceived = received == null;

        if (!needsSent && !needsReceived) {
          skipped += 1;
          continue;
        }

        const patch = {
          giftSeededAt: serverTimestamp(),
        };
        if (needsSent) patch.giftCoinsSent = 0;
        if (needsReceived) patch.giftCoinsReceived = 0;

        batch.set(ref, patch, { merge: true });
        updated += 1;

        batchCount += 1;

        // Firestore limit: 500 writes per batch
        if (batchCount >= 450) {
          addDebug(`📤 Committing batch chunk (${batchCount} writes)...`);
          await batch.commit();
          batch = writeBatch(db);
          batchCount = 0;
        }
      }

      if (batchCount > 0) {
        addDebug(`📤 Committing final batch chunk (${batchCount} writes)...`);
        await batch.commit();
      }

      setMsg(`✅ Done. Updated: ${updated}. Skipped (already had fields): ${skipped}.`);
      addDebug(`✅ Updated: ${updated} | Skipped: ${skipped}`);
    } catch (e) {
      console.error(e);
      addDebug("❌ ERROR OCCURRED:");
      addDebug(String(e?.message || e));
      setMsg(`❌ Error: ${String(e?.message || e)}`);
    } finally {
      setRunning(false);
      addDebug("🏁 Seed process finished.");
    }
  }

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: 0 }}>🧪 Seed Gift Fields (SAFE)</h2>

      <p style={{ marginTop: 8, opacity: 0.75, fontWeight: 700 }}>
        This will only create missing <b>giftCoinsSent</b> / <b>giftCoinsReceived</b>.
        It will <b>NOT</b> reset existing totals.
      </p>

      <button
        type="button"
        onClick={seed}
        disabled={running}
        style={{
          padding: "12px 14px",
          borderRadius: 12,
          border: "1px solid rgba(0,0,0,0.15)",
          fontWeight: 900,
          cursor: running ? "not-allowed" : "pointer",
        }}
      >
        {running ? "Running..." : "Run Safe Seed"}
      </button>

      {msg && (
        <div
          style={{
            marginTop: 14,
            padding: 12,
            borderRadius: 12,
            background: "#e8f5e9",
            border: "1px solid #4caf50",
            fontWeight: 800,
          }}
        >
          {msg}
        </div>
      )}

      {debug.length > 0 && (
        <div
          style={{
            marginTop: 20,
            padding: 14,
            borderRadius: 12,
            background: "#111",
            color: "#00ff88",
            fontSize: 12,
            fontFamily: "monospace",
            maxHeight: 300,
            overflowY: "auto",
            border: "1px solid #333",
          }}
        >
          {debug.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
}